import script from "./AccountBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountBalance.vue?vue&type=script&setup=true&lang=ts"

import "./AccountBalance.vue?vue&type=style&index=0&id=69e1e05a&lang=css"

const __exports__ = script;

export default __exports__